module.exports = __webpack_public_path__ + "media/images/icons/open-in-new-blue-c3517e48a1ee133674433c6cc8dc96bd.svg";